import { render } from "./WarpcastLink.vue?vue&type=template&id=ef363e8c&scoped=true"
import script from "./WarpcastLink.vue?vue&type=script&lang=js"
export * from "./WarpcastLink.vue?vue&type=script&lang=js"

import "./WarpcastLink.vue?vue&type=style&index=0&id=ef363e8c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef363e8c"]])

export default __exports__